import { render, staticRenderFns } from "./sb.vue?vue&type=template&id=8991137c&scoped=true"
import script from "./sb.vue?vue&type=script&lang=js"
export * from "./sb.vue?vue&type=script&lang=js"
import style0 from "./sb.vue?vue&type=style&index=0&id=8991137c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991137c",
  null
  
)

export default component.exports